
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const CSSLoader = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (isAdminRoute) {
      import('../adminapp/styles/MainAdmin.css');
    } else {
      import('../core/styles/MainCore.css');
    }
  }, [isAdminRoute]);

  return null;
};
export default CSSLoader;